import { noop } from "lodash";

export const ModalV2DefaultProps = {
  title: null,
  subtitle: null,
  titleType: "default",
  isOpen: false,
  onOpen: noop,
  hasClose: true,
  onClose: noop,
  onBack: null,
  onOverlayClick: null,
  hasOverlay: true,
  isFullWidth: true,
  isFullHeight: true,
  isFluidWidth: false,
  hasRoundedCorners: true,
  animation: "right",
  offsetTop: 16,
  offsetBottom: 0,
  offsetLeft: 0,
  offsetRight: 0,
  hasVideoOffset: false,
  children: noop,
  qaLabel: null,
  modalTopChildren: noop,
  isLastModal: true,
  fixIosKeyboard: false,
  useFakeInput: false,
  hasHeader: true,
  device: "mobile",
  hasShadow: true,
  hasBottomCorners: false,
  isCapitalized: true,
  isSubTitleUppercase: true,
  icon: null,
  hasSafeArea: true,
  titleBadgeCounter: undefined,
  displayZeroTitleBadge: false,
  footer: undefined
};

export const ModalDefaultProps = {
  title: null,
  subtitle: null,
  titleType: "default",
  isOpen: false,
  onOpen: noop,
  hasClose: true,
  onClose: noop,
  onBack: null,
  onOverlayClick: null,
  hasOverlay: true,
  isFullWidth: true,
  isFullHeight: true,
  isFluidWidth: false,
  hasRoundedCorners: true,
  animation: "right",
  offsetTop: 16,
  offsetBottom: 0,
  offsetLeft: 0,
  offsetRight: 0,
  hasVideoOffset: false,
  children: noop,
  modalTopChildren: noop,
  qaLabel: null,
  fixIosKeyboard: false,
  hasHeader: true,
  device: "mobile",
  isContentTransparent: false,
  hasCloseWithoutHeader: false,
  hasShadow: true,
  hasBottomCorners: false,
  isCapitalized: true,
  isSubTitleUppercase: true,
  hasSafeArea: true,
  icon: null,
  titleBadgeNumber: undefined,
  displayZeroTitleBadge: false,
  footer: undefined,
  useCloseLabel: undefined
};
